import styled from "@emotion/styled";

export const FormButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  margin: 0.5rem 0;
`;
